import { Component, OnInit } from '@angular/core';
import { RewardsWalletItem, RewardsWalletQuery, RewardsWalletService } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-wallet-claimed-page',
  templateUrl: './wallet-claimed-page.component.html',
  styleUrls: ['./wallet-claimed-page.component.scss'],
})
export class WalletClaimedPageComponent implements OnInit {
  walletItemsClaimed$: Observable<RewardsWalletItem[]>;

  constructor(private rewardsWalletQuery: RewardsWalletQuery, private rewardsWalletService: RewardsWalletService) {}

  ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItemsClaimed$ = this.rewardsWalletQuery.selectRewardWalletItemsHistory();
  }
}
